import { config } from '@shopee-user/platform';
import { Locale } from '@shopee-user/global';
import { NoCostLoginMethod } from '@tob/shared/no-cost-authentication/constants';

const isLiveEnv = config.ENV === 'live' || config.ENV === 'liveish';

export function getQuickLoginActivationCooldown() {
  return isLiveEnv
    ? 7 * 24 * 60 * 60 * 1000 // 7 days to ms
    : 10 * 60 * 1000; // 10 minutes to ms in non-live;
}

export function getNoCostAuthenticationActivationPromptSequence() {
  switch (config.LOCALE) {
    case Locale.ID:
    case Locale.MY:
      return [NoCostLoginMethod.QuickLogin, NoCostLoginMethod.Biometrics];
    default:
      return [NoCostLoginMethod.Biometrics];
  }
}
